import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.2754 16.7002L12.5996 19.3496C12.0663 19.8829 11.4586 20.2919 10.7754 20.5752C10.0921 20.8585 9.375 21 8.625 21C7.05833 21 5.72936 20.454 4.6377 19.3623C3.54603 18.2706 3 16.9417 3 15.375C3 14.625 3.14147 13.9079 3.4248 13.2246C3.70813 12.5414 4.11713 11.9337 4.65039 11.4004L7.2998 8.72461L15.2754 16.7002ZM15.375 3C16.9417 3 18.2706 3.54603 19.3623 4.6377C20.454 5.72936 21 7.05833 21 8.625C21 9.375 20.8585 10.0921 20.5752 10.7754C20.2919 11.4586 19.8829 12.0663 19.3496 12.5996L16.7002 15.2754L8.72461 7.2998L11.4004 4.65039C11.9337 4.11713 12.5414 3.70813 13.2246 3.4248C13.9079 3.14147 14.625 3 15.375 3Z" })
});
export default SvgPill;
